if (!customElements.get("size-guide-display")) {
  // Product accordion
  customElements.define(
    "size-guide-display",
    class SizeGuideDisplay extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        // connectedCallback re-fires whenever the element is moved in the DOM —
        // pdp-tabs.js re-parents each panel's children into a "Read more" wrapper,
        // which would otherwise inject the size guide a second time. Inject once.
        if (this._loaded) return;

        var sg_template = document.querySelector(".size-guide-template");

        if (this.hasAttribute("client-side")) {
          var product_tags_string = this.dataset.prodTags;

          var product_tags = product_tags_string.split(",");

          if (product_tags.length == 0) return;

          for (let i = 0; i < product_tags.length; i++) {
            const tag = product_tags[i];

            var tag_sg_template = document.querySelector(
              `.size-guide-template[data-tag="${tag}"]`,
            );

            if (tag_sg_template) {
              sg_template = tag_sg_template;
              break;
            }
          }
        }
        if (!sg_template) {
          this.hideContainer();
          return;
        }

        //get innerHTML and append
        const templateContent = sg_template.content;

        // Create a deep clone of the template content
        const clone = templateContent.cloneNode(true);

        // Append the cloned content to the web component
        this.appendChild(clone);
        this._loaded = true;
      }

      // With no size guide to show, hide the wrapper. This element lives in
      // either a collapsible accordion row (.product__accordion) or a PDP tab
      // panel (.pdp-tabs__item) — hide whichever wraps it. For tabs, also hide
      // the matching header tab so no empty "Size Guide" tab is left behind.
      hideContainer() {
        const accordion = this.closest(".product__accordion");
        if (accordion) {
          accordion.classList.add("hide");
          return;
        }

        const panel = this.closest(".pdp-tabs__item");
        if (!panel) return;

        panel.classList.add("hide");

        const tabs = this.closest("pdp-tabs");
        const index = panel.dataset.index;
        if (tabs && index != null) {
          const header = tabs.querySelector(
            `.pdp-tab[data-index="${index}"]`,
          );
          if (header) header.classList.add("hide");
        }
      }
    },
  );
}
if (!customElements.get("size-guide")) {
  customElements.define(
    "size-guide",
    class SizeGuide extends HTMLElement {
      constructor() {
        super();
        //init modal
      }
    },
  );
}
